import { render } from "./H5ExamResultView.vue?vue&type=template&id=6144915c&scoped=true"
import script from "./H5ExamResultView.vue?vue&type=script&lang=js"
export * from "./H5ExamResultView.vue?vue&type=script&lang=js"

import "./H5ExamResultView.vue?vue&type=style&index=0&id=6144915c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144915c"]])

export default __exports__